/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import {
  Button,
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Modal,
} from 'react-bootstrap';
import ControlTips from 'loracoms/ControlTips';
import FormBlock from 'loracoms/FormBlock';
import RichButton from 'loracoms/RichButton';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import { callAPI } from 'lorautils/api';
import {
  isValidAppEUI,
  formatAppEUIInput,
  normalizeAppEUI,
} from 'lorautils/IdUtils';
import styles from './styles.scss';


const propTypes = {
  intl: React.PropTypes.object.isRequired,
  show: React.PropTypes.bool.isRequired,
  onOOQ: React.PropTypes.func.isRequired,
  onAdded: React.PropTypes.func.isRequired,
  onHide: React.PropTypes.func.isRequired,
};

class AddAppModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      errors: (
        ErrorSet
          .createEmpty()
          .add('FE_EMPTY', 'name')
          .add('FE_EMPTY', 'appeui')
      ),
    };
    this.intlMsg = new IntlMsg(props.intl, 'application.addapp');
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeAppEUI = this.handleChangeAppEUI.bind(this);
    this.handleRandomAppEUI = this.handleRandomAppEUI.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleHide = this.handleHide.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { show } = nextProps;
    if (show !== this.props.show) {
      this.setState({ show });
    }
  }

  componentDidUpdate() {
    const { appeuiCurPos } = this.state;
    if (appeuiCurPos) {
      this.appeuiRef.setSelectionRange(appeuiCurPos, appeuiCurPos);
    }
  }

  reset() {
    this.setState({
      status: '',
      name: '',
      appeui: '',
      appeuiCurPos: null,
      submitted: false,
      errors: (
        ErrorSet
          .createEmpty()
          .add('FE_EMPTY', 'name')
          .add('FE_EMPTY', 'appeui')
      ),
    });
  }

  handleChangeName(e) {
    const name = e.target.value;
    this.setState({ name });

    const { errors } = this.state;

    if (name === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'name') });
    } else {
      this.setState({ errors: errors.remove('name') });
    }
  }

  handleChangeAppEUI(e) {
    let { appeui, appeuiCurPos } = this.state;
    appeui = formatAppEUIInput(e.target.value, appeui);
    appeuiCurPos = e.target.selectionEnd;
    if (e.target.value.length === appeuiCurPos) {
      appeuiCurPos = appeui.length;
    }
    this.setState({ appeui, appeuiCurPos });

    const { errors } = this.state;
    if (appeui === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'appeui') });
    } else if (!isValidAppEUI(appeui)) {
      this.setState({ errors: errors.add('FE_INVALID', 'appeui') });
    } else {
      this.setState({ errors: errors.remove('appeui') });
    }
  }

  handleRandomAppEUI() {
    const appeui = _.map(
      _.range(18),
      () => _.sample('ABCDEF0123456789'),
    ).join('');
    this.setState({
      appeui: normalizeAppEUI(appeui),
      errors: this.state.errors.remove('appeui'),
    });
  }

  handleHide() {
    const { onHide } = this.props;
    this.reset();
    onHide();
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ submitted: true });

    const { onOOQ, onAdded } = this.props;
    let { name, appeui, errors } = this.state;
    errors = errors.remove('submit');
    if (!errors.isEmpty()) {
      return;
    }

    name = name.trim();
    appeui = appeui.replace(/[:-]/g, '');

    this.setState({ status: 'pending' });
    callAPI({
      endpoint: '/lora/applications',
      body: {
        name,
        appeui,
      },
      method: 'POST',
    }).then(() => {
      this.setState({
        status: 'success',
      });
      _.delay(() => {
        this.reset();
        onAdded();
      }, 500);
    }).catch((error) => {
      this.setState({ status: 'failure' });
      if (error.code === 'QUOTA') {
        onOOQ();
      } else {
        this.setState({
          errors: errors.add(error.code, 'submit'),
          status: 'failure',
        });
        _.delay(() => {
          this.setState({
            status: '',
            errors: this.state.errors.remove('submit'),
          });
        }, 1500);
      }
    });
  }

  render() {
    const {
      show = false,
      name = '',
      appeui = '',
      status = '',
      errors,
      submitted = false,
    } = this.state;
    return (
      <Modal
        bsClass="aisz-modal-light"
        backdrop="static"
        show={show}
        onHide={this.handleHide}
      >
        <Modal.Header closeButton>
          {this.intlMsg.msg('header')}
        </Modal.Header>
        <Modal.Body>
          <Form horizontal onSubmit={this.handleSubmit}>
            <FormGroup validationState={submitted && errors.has('name') ? 'error' : undefined}>
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('appname.label')}
                </ControlLabel>
              </Col>
              <Col md={6}>
                <FormControl
                  bsClass="aisz-form-control-f"
                  placeholder={this.intlMsg.msg('appname.placeholder')}
                  value={name}
                  onChange={this.handleChangeName}
                />
                <ControlTips
                  message={this.intlMsg.errorMsg(errors.get('name'))}
                  show={submitted && errors.has('name')}
                  azStyle="danger"
                />
              </Col>
            </FormGroup>
            <FormGroup validationState={submitted && errors.has('appeui') ? 'error' : undefined}>
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('appeui.label')}
                </ControlLabel>
              </Col>
              <Col md={6}>
                <FormControl
                  bsClass="aisz-form-control-f"
                  placeholder="01-23-45-67-89-AB-CD-EF"
                  value={appeui}
                  onChange={this.handleChangeAppEUI}
                  onBlur={() => { this.setState({ appeuiCurPos: null }); }}
                  inputRef={(ref) => { this.appeuiRef = ref; }}
                />
                <ControlTips
                  message={this.intlMsg.errorMsg(errors.get('appeui'))}
                  show={submitted && errors.has('appeui')}
                  azStyle="danger"
                />
                <div className={styles.random}>
                  <Button
                    bsStyle="aisz-link"
                    onClick={this.handleRandomAppEUI}
                  >
                    {this.intlMsg.msg('random')}
                  </Button>
                </div>
              </Col>
            </FormGroup>
            <FormGroup>
              <Col mdOffset={3} md={6}>
                <div className={styles.submit}>
                  <RichButton
                    status={status}
                    states={[{
                      status: 'default',
                      label: this.intlMsg.msg('submit'),
                      style: 'primary',
                      type: 'submit',
                    }, {
                      status: 'pending',
                      label: this.intlMsg.msg('submit.pending'),
                      style: 'primary',
                    }, {
                      status: 'success',
                      label: this.intlMsg.msg('submit.success'),
                      style: 'success',
                    }, {
                      status: 'failure',
                      label: this.intlMsg.msg('submit.failure'),
                      style: 'danger',
                    }]}
                  />
                </div>
              </Col>
            </FormGroup>
            <FormGroup>
              <Col mdOffset={3} md={6}>
                <FormBlock
                  message={this.intlMsg.errorMsg(errors.get('submit'))}
                  show={errors.has('submit')}
                  azStyle="danger"
                />
              </Col>
            </FormGroup>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

AddAppModal.propTypes = propTypes;

export default injectIntl(AddAppModal);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/AddAppModal/index.jsx